import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { downloadBlob } from '@/shared/utils/downloadBlob';
import { buildCsv } from '@/shared/utils/tableControls';

const download = (columns, rows, filename) => {
    // The byte-order mark makes Excel read the file as UTF-8
    const blob = new Blob(['﻿', buildCsv(columns, rows)], {
        type: 'text/csv;charset=utf-8',
    });
    downloadBlob(blob, filename);
};

/**
 * One "Export CSV" menu, a secondary action beside the table it exports: "All rows (N)" always, and "Filtered rows (M)" only
 * while a search or filter narrows the table. Both are built from the table's
 * own columns and the same accessors as its cells, so an export never carries
 * a field the screen does not. A program that also keeps a server spreadsheet
 * of every field offers it as its own item, `onExportFull`, named so nobody
 * mistakes it for the table; `exporting` marks that download as running.
 */
export default function ExportCsvMenu({
    columns,
    allRows,
    filteredRows,
    filtersActive,
    filename,
    className = '',
    onExportFull = null,
    fullNote = '',
    exporting = false,
}) {
    const exportFull = () => {
        if (!exporting) onExportFull();
    };
    return (
        <Dropdown align="end" className="d-inline-block">
            <Dropdown.Toggle
                variant="outline-primary"
                size="sm"
                className={className}
                aria-disabled={exporting}
            >
                {exporting ? 'Exporting...' : 'Export CSV'}
            </Dropdown.Toggle>
            <Dropdown.Menu role="menu" className="export-csv-menu">
                <Dropdown.Item
                    as="button"
                    type="button"
                    role="menuitem"
                    onClick={() => download(columns, allRows, filename)}
                >
                    All rows ({allRows.length})
                </Dropdown.Item>
                {filtersActive && (
                    <Dropdown.Item
                        as="button"
                        type="button"
                        role="menuitem"
                        onClick={() =>
                            download(columns, filteredRows, filename)
                        }
                    >
                        Filtered rows ({filteredRows.length})
                    </Dropdown.Item>
                )}
                {onExportFull && (
                    <Dropdown.Item
                        as="button"
                        type="button"
                        role="menuitem"
                        className="text-wrap"
                        onClick={exportFull}
                    >
                        Full spreadsheet
                        {fullNote && (
                            <small className="d-block text-muted">
                                {fullNote}
                            </small>
                        )}
                    </Dropdown.Item>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
}
